// Bandeira circular de cada idioma (pop-up de boas-vindas — AC-127). Desenhada em SVG:
// o Windows não mostra emoji de bandeira.
import type { Language } from '../domain/settings';

const W = 32;

function Stripes({ colors, vertical = false }: { colors: string[]; vertical?: boolean }) {
  const size = W / colors.length;
  return (
    <>
      {colors.map((c, i) =>
        vertical ? <rect key={i} x={i * size} y={0} width={size} height={W} fill={c} /> : <rect key={i} x={0} y={i * size} width={W} height={size} fill={c} />
      )}
    </>
  );
}

const FLAGS: Record<Language, () => JSX.Element> = {
  // Brasil
  'pt-BR': () => (
    <>
      <rect width={W} height={W} fill="#009C3B" />
      <path d="M16 5 29 16 16 27 3 16Z" fill="#FFDF00" />
      <circle cx="16" cy="16" r="6.4" fill="#002776" />
      <path d="M9.8 14.6c4-1.2 8.6-.7 12.3 1.6" stroke="#fff" strokeWidth="1.3" fill="none" />
    </>
  ),
  // Estados Unidos
  en: () => (
    <>
      <Stripes colors={['#B22234', '#fff', '#B22234', '#fff', '#B22234', '#fff', '#B22234']} />
      <rect width="15" height="15" fill="#3C3B6E" />
      {[3, 7.5, 12].flatMap((y) => [3, 7.5, 12].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1" fill="#fff" />))}
    </>
  ),
  // Espanha
  es: () => (
    <>
      <rect width={W} height={W} fill="#AA151B" />
      <rect y="8" width={W} height="16" fill="#F1BF00" />
    </>
  ),
  // França
  fr: () => <Stripes vertical colors={['#002395', '#fff', '#ED2939']} />,
  // Alemanha
  de: () => <Stripes colors={['#000', '#DD0000', '#FFCE00']} />,
  // Itália
  it: () => <Stripes vertical colors={['#009246', '#fff', '#CE2B37']} />,
  // Portugal
  'pt-PT': () => (
    <>
      <rect width={W} height={W} fill="#FF0000" />
      <rect width="12.8" height={W} fill="#006600" />
      <circle cx="12.8" cy="16" r="5.2" fill="#FFCC00" />
      <circle cx="12.8" cy="16" r="3" fill="#FF0000" stroke="#fff" strokeWidth="1" />
    </>
  ),
};

export function Flag({ lang, size = 22 }: { lang: Language; size?: number }) {
  const Draw = FLAGS[lang];
  const clip = `flag-${lang}`;
  return (
    <svg className="flag" width={size} height={size} viewBox={`0 0 ${W} ${W}`} aria-hidden="true" focusable="false" data-flag={lang}>
      <defs>
        <clipPath id={clip}>
          <circle cx="16" cy="16" r="16" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clip})`}>
        <Draw />
      </g>
      <circle cx="16" cy="16" r="15.5" fill="none" stroke="rgba(0,0,0,0.18)" />
    </svg>
  );
}
